import React from "react";

const getSeatDescription = (seat) => {
  let description;

  if (seat.area) {
    description = `Area ${seat.area}`;
  }

  if (seat.row) {
    description += `, Row ${seat.row}`;
  }

  if (seat.seat) {
    description += `, Seat ${seat.seat}`;
  }

  if (seat.side) {
    description += ` ${seat.side}`;
  }

  if (!description) {
    description = "-";
  }

  return description;
};

export const SeatsDescription = ({ seats }) => {
  if (seats && seats.length > 0) {
    return (
      <ul>
        {seats.map((seat) => (
          <li key={seat.id}>{getSeatDescription(seat)}</li>
        ))}
      </ul>
    );
  } else {
    return "-";
  }
};
